// extracted by mini-css-extract-plugin
export default {"wizard-header":"wizard-modal_wizard-header__RhGw5","wizard-content":"wizard-modal_wizard-content__eMcGA"};